import {PastCall, PaginatedPastCalls} from "../../domain/types";
import {V2PastCallItem, V2PastCallsData} from "./mapper.types";

/**
 * Maps v2 API responses to past-calls domain types.
 * The v2 API already uses camelCase and provides full pagination support.
 *
 * Pure TypeScript - no React imports.
 */
export const PastCallsMapperV2 = {
  /**
   * Maps a single v2 past-call item to the domain PastCall.
   */
  toDomain(item: V2PastCallItem): PastCall {
    return {
      id: item.id,
      reference: item.reference,
      serviceName: item.serviceName,
      serviceDescription: item.serviceDescription ?? "",
      firstName: item.firstName,
      lastName: item.lastName,
      emailAddress: item.emailAddress,
      phoneNumber: item.phoneNumber ?? null,
      currency: item.currency ?? "",
      amount: item.amount,
      bookingYear: String(item.bookingYear),
      bookingMonth: String(item.bookingMonth),
      bookingDate: item.bookingDate,
      coachFromTime: item.coachFromTime ?? "",
      coachToTime: item.coachToTime ?? "",
      timeslot: item.timeslot,
      duration: item.duration,
      bookingType: item.bookingType,
      bundleSession: item.bundleSession ?? null,
      bundleSessionCount: item.bundleSessionCount ?? null,
      bookingQuestions: item.bookingQuestions || "[]",
      videoPlatform: item.videoPlatform ?? null,
      roomId: item.roomId ?? null,
    };
  },

  /**
   * Maps the v2 paginated payload to the domain PaginatedPastCalls.
   */
  toPaginated(data: V2PastCallsData): PaginatedPastCalls {
    return {
      data: (data.data ?? []).map(PastCallsMapperV2.toDomain),
      total: data.total ?? 0,
      hasNextPage: data.hasNextPage ?? false,
      hasPrevPage: data.hasPrevPage ?? false,
    };
  },
};
